import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from 'app/services/models/company.service';
import { ProductService } from 'app/services/models/product.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import * as moment from 'moment';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TaxService } from 'app/services/models/tax.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { TransactionProductService } from 'app/services/models/transaction-product.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { TransactionProductCreate } from 'app/dtos/TransactionProduct/CreateTransactionProduct';
import { ToastrService } from 'ngx-toastr';
import { WarehouseService } from 'app/services/models/warehouse.service';

@Component({
  selector: 'app-transaction-create-dilaog',
  templateUrl: './transaction-create-dilaog.component.html',
  styleUrls: ['./transaction-create-dilaog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TransactionCreateDilaogComponent implements OnInit {
  @Input() data: { message: string; product: {}; discountRate: number; transactionId?: number, kindId?: number };
  isSerialProduct: boolean = false;
  serialNumbers: string[] = [];
  saleSeriNo: number[] = [];
  constructor(
    public ngbModal: NgbActiveModal,
    private productService: ProductService,
    private taxService: TaxService,
    private currencyService: CurrencyService,
    private modalService: NgbModal,
    private transactionProductService: TransactionProductService,
    private transactionService: TransactionService,
    private toastrService: ToastrService,
    private warehouseService: WarehouseService) { }

  allTax: any[] = [];
  currencies: any[] = [];
  product: any = {};

  count = 1;
  description: string;
  discountRate: number = 0;
  total: number = 0;
  warehouses: any[] = [];
  selectedWarehouseId: number;
  selectedCurrencyId: number;

  purchasePrice: number = 0;

  public priceDifferencePercentage: number = 0;

  async ngOnInit() {
    console.log(this.data);
    this.discountRate = this.data.discountRate ?? 0;
    await this.getAllTax();
    await this.getAllCurrency();
    await this.getAllWarehouse();
    await this.getByIdProduct(this.data.product);
  }

  toggleSerialInput(): void {
    if (this.isSerialProduct && this.data?.kindId == 6) {
      console.log(this.saleSeriNo);
      this.count = 0;
      this.saleSeriNo = [];
    } else if (this.isSerialProduct && this.data.kindId == 5) {
      this.updateSerialInputs();
    }
    else {
      this.saleSeriNo = [];
      this.serialNumbers = []; // Checkbox kapatıldığında seri numaralarını temizle
    }
  }

  // Adet değişimini kontrol eden metot
  checkSerialInput(): void {
    if (this.isSerialProduct) {
      this.updateSerialInputs();
    }
  }

  preventFocusLoss(index: number): void {
    const element = document.getElementById(`serial-${index}`) as HTMLInputElement;
    if (element) {
      element.focus();
    }
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  setCount(value: number): void {
    this.count = value;
    this.serialNumbers = Array(value).fill('');
  }
  // Seri numarası inputlarını güncelle
  private updateSerialInputs(): void {
    if (this.isSerialProduct && this.count > 0) {
      const currentLength = this.serialNumbers.length;

      // Eğer count mevcut sayıdan büyükse, eksik sayıda input ekle
      if (this.count > currentLength) {
        for (let i = currentLength; i < this.count; i++) {
          this.serialNumbers.push('');
        }
      }

      // Eğer count mevcut sayıdan küçükse, fazlalık inputları sil
      if (this.count < currentLength) {
        this.serialNumbers.splice(this.count);
      }
    } else {
      this.serialNumbers = []; // Checkbox kapalıysa veya count 0'sa temizle
    }
  }

  isAllSerialNumbersFilled(): boolean {
    if (this.data.kindId === 5) {
      if (this.isSerialProduct && this.serialNumbers.length > 0) {
        return this.serialNumbers.every(serial => serial.trim() !== '');
      }
      return true;
    } else {
      return false;
    }
  }

  updateSelectedSerials(seri: any): void {
    if (this.saleSeriNo.includes(seri.id)) {
        // Checkbox işareti kaldırıldığında ID'yi çıkar
        const index = this.saleSeriNo.indexOf(seri.id);
        if (index > -1) {
            this.saleSeriNo.splice(index, 1);
        }
    } else {
        // Checkbox seçildiğinde ID'yi ekle
        this.saleSeriNo.push(seri.id);
    }

    this.count = this.saleSeriNo.length;

    if (!this.isSerialProduct) {
        this.saleSeriNo = []; // Seri numarası kapalıysa listeyi sıfırla
    }

    this.calculateTotalPrice();
    this.allFieldsFilled();
    console.log('Seçilen Seri Numaraları:', this.saleSeriNo);
}


  async getAllWarehouse() {
    const data = await this.warehouseService.getAllWarehouses(0, 100, '');
    this.warehouses = data.warehouses;
    console.log(this.warehouses);
  }

  getProductCountDifference(warehouseId: number): number {
    const productCount = this.product.transactionProductsCount?.find(pc => pc.warehouseId === warehouseId);
    return productCount ? productCount.totalProductCountDifference : 0;
  }

  async getByIdProduct(product) {
    const data = await this.productService.getByIdProduct(product.id);
    this.product = data;
    console.log(this.product);
    this.selectedWarehouseId = this.warehouses[0].id;
    this.purchasePrice = this.product?.purchasePrice ?? 0;
    this.selectedCurrencyId = this.product?.currencyId ?? this.currencies[0].id;
    this.product.saleTaxId = this.product?.saleTaxId ?? this.allTax[0].id
    this.calculateTotalPrice();
    this.calculatePriceDifferencePercentage();
  }

  calculatePriceDifferencePercentage(): void {
    const purchasePrice = this.purchasePrice || 0; // Ensure this is correctly bound to the purchase price
    const salePrice = parseFloat(this.product.salePrice) || 0; // This binds to the sale price input

    if (purchasePrice > 0) { // Prevent division by zero
      this.priceDifferencePercentage = ((salePrice - purchasePrice) / purchasePrice) * 100;
    } else {
      this.priceDifferencePercentage = 0; // Reset if purchase price is 0
    }
  }

  resetForm() {
    this.product = {};
    this.count = 1;
    this.description = '';
    this.discountRate = 0;
    this.total = 0;
    this.selectedWarehouseId = null;
    this.purchasePrice = 0;
    this.selectedWarehouseId = null;
  }

  onWarehouseChange(event: any) {
    this.selectedWarehouseId = event.target.value;
    console.log("Seçilen Depo ID:", this.selectedWarehouseId);
  }

  onCurrencySelect(event: any) {
    const selectedValue = event.target.value; // Seçilen değeri almak için
    console.log("Seçilen para:", selectedValue);
    this.selectedCurrencyId = selectedValue;
  }


  async calculateTotalPrice() {
    const salePrice = this.product.salePrice || 0;
    const discount = this.discountRate || 0;
    const tax = this.allTax.find((tax) => tax.id === this.product.saleTaxId)?.taxRate || 0;

    const discountedPrice = salePrice - (salePrice * discount) / 100;
    const totalWithTax = discountedPrice + (discountedPrice * tax) / 100;

    this.total = parseFloat((this.count * totalWithTax).toFixed(2));

  }

  async calculateSalePriceFromTotal() {
    const discount = this.discountRate || 0;
    const tax = this.allTax.find((tax) => tax.id === this.product.saleTaxId)?.taxRate || 0;

    const totalWithoutTax = this.total / (1 + tax / 100);
    const salePrice = totalWithoutTax / (1 - discount / 100);

    this.product.salePrice = (salePrice / this.count).toFixed(2);
    console.log("Satış fiyatı : ", this.product.salePrice);
  }

  async getAllTax() {
    const data = await this.taxService.getAllTax(0, 100, '');
    console.log(data);
    this.allTax = data.taxex;
  }

  async getAllCurrency() {
    const data = await this.currencyService.getAllPageCurrency(0, 100, '');
    console.log(data);
    this.currencies = data.currenies;
  }

  onSaleTaxChange(event: any) {
    console.log(event.target.value);
    const selectedTax = this.allTax.find(tax => tax.id === Number(event.target.value));
    console.log(selectedTax);
    if (selectedTax) {
      this.product.saleTaxId = selectedTax.id
      this.product.saleTax = selectedTax.taxRate;
    } else {
      this.product.saleTax = null; // Handle case where no tax is selected
    }
    this.calculateTotalPrice();
  }

  async addTransactionProduct() {

    const transactionProduct: TransactionProductCreate = {
      currencyId: this.selectedCurrencyId,
      description: this.description,
      discountRate: this.discountRate,
      productCount: this.count,
      productId: this.product.id, // Ürün ID'sini kullanın
      productPrice: this.product.salePrice, // Satış fiyatı
      taxId: this.product.saleTaxId, // Vergi ID'si
      transactionId: this.data?.transactionId, // İşlem ID'si
      warehouseId: this.selectedWarehouseId, // Depo ID'si
      seriNos:this.serialNumbers,
      saleSerialNos:this.saleSeriNo
    };

    console.log(transactionProduct);
    const response = await this.transactionProductService.transactionProductCreate(transactionProduct);
    if (response.status == true) {
      this.toastrService.success(response.message);
      this.transactionService.sendEvent(true);
      this.closeModal();
    }

  }

  addTransaction() {
    //daha önce oluşmayan teklif detayına ürün eklemek için kullanılacak
    const transactionData = {
      product: this.product,
      count: this.count,
      selectedWarehouseId: this.selectedWarehouseId,
      salePrice: this.product.salePrice,
      saleTax: this.product.saleTax,
      saleTaxId: this.product.saleTaxId,
      discountRate: this.discountRate,
      total: this.total,
      currencyId: this.selectedCurrencyId,
      description: this.description,
      seriNos: this.serialNumbers,
      saleSerialNos: this.saleSeriNo
    };

    this.ngbModal.close(transactionData);

    this.resetForm();
  }

  allFieldsFilled(): boolean {
    return this.count != null && this.count > 0 &&
      this.selectedWarehouseId != null &&
      this.product?.salePrice != null &&
      this.product?.saleTaxId != null &&
      this.discountRate != null && this.discountRate >= 0 &&
      this.total != null &&
      this.selectedCurrencyId != null;
  }

  closeModal() {
    this.ngbModal.close();
  }

}
